import React, {createRef, useState} from "react";
import {appSelector} from "../../redux/app/selectors";
import {useDispatch} from "react-redux";
import {actions as appActions} from "../../redux/app";
import ReCAPTCHA from "react-google-recaptcha";
// material-ui components
import {TransitionProps} from "@mui/material/transitions";
import styled from "styled-components";
import PhoneIcon from "../icons/PhoneIcon";
import {handleSubmit} from "../../lib/utils";
import {validateInput} from "../../lib/validation";
import {media} from "../../../styles/styles";
import {useRouter} from 'next/router'
import {Close} from "@mui/icons-material";
import {
    Button,
    Grid,
    FormControlLabel,
    Slide,
    Dialog,
    DialogContent,
    DialogTitle,
    Checkbox,
    TextField,
    FormHelperText,
    CircularProgress,
    Typography,
    IconButton
} from "@mui/material";
import {Event} from '../../../utils/gtm';
import {FbEvent} from '../../../utils/fbq';
// core components
const StyledPhoneIcon = styled(PhoneIcon)`
    position: relative !important;
    left: 0 !important;
    top: 0.5em !important;
    font-size: 1.6em !important;

    path {
        stroke: #de4a22;
    }
`;
const PhoneNumber = styled.div`
    font-size: 1.5em;
    width: 100%;
    text-align: center;
    font-weight: bold;

    .phone_number {
        &:hover {
            color: #E55934;
            text-decoration: underline;
        }
    }
`;
const StyledButton = styled(Button)`
    && {
        background-color: #de4a22;
        color: #fff;
        padding: 0.8em 4em;

        ${media.phone`
    width: 100%;`}
        &:hover {
            background-color: #fff;
            color: #de4a22;
        }
    }
`;
const Transition = React.forwardRef<
    unknown,
    TransitionProps & { children: any } // style required for some reason? https://github.com/mui-org/material-ui/pull/20306/files/0ed8aff241d2fb6fbc13819d57a893b1497b1506
>((props, ref) => <Slide direction="down" ref={ref} {...props} />);
Transition.displayName = `Transition`

const Form = styled.form`
    & > .MuiFormControl-root {
        &:nth-of-type(odd) {
            margin: 2% 3% 2% 0;
        }

        &:nth-of-type(even) {
            margin: 2% 0 2% 3%;
        }

        width: 47%;
        ${media.phone`
    width: 100%;
    &:nth-of-type(odd),&:nth-of-type(even) {
      margin: 2% 0 2% 0;
    }
  `};
    }
`;
const StyledDialog = styled(Dialog)`
    overflow-y: scroll;

    && {
        .MuiPaper-root {
            max-width: 600px;
        }
    }
`;
const StyledFooterDialog = styled(DialogContent)`
    overflow-y: initial;

    && {
        padding: 2em;
        ${media.phone`
    padding: 0;`}
    }
`;
const StyledFooterGrid = styled(Grid)`
    && {
        background-color: #f0f0f0;
        border-radius: 6px;
        line-height: 1.7em;
        padding: 2rem;
        ${media.phone`
    padding:  0.5em 2em;`}
    }
`;
const StyledSubmitGrid = styled(Grid)`
    margin: 2rem 0 0;
    ${media.phone`margin: 0;`}
`;
const RightAlignGrid = styled(Grid)`
    text-align: right;
`;
const StyledDialogTitle = styled(DialogTitle)<{ component?: React.ElementType }>`
    && {
        padding: 0 24px;

        h2 {
            margin-top: 40px;
        }
    }
`;
const FullWidthInput = styled(TextField)`
    &.MuiFormControl-root {
        width: 100%;
    }
`;
const StyledIconButton = styled(IconButton)`
    &.MuiButtonBase-root {
        color: #de4a22;
        position: absolute;
        right: 1rem;
    }
`;

const OperatingTimes = styled.p`
    white-space: pre-wrap;
`

export default function EnquiryModal({operatingTimes}: any) {
    const {modal, phoneNumber} = appSelector((state) => state.app);
    const dispatch = useDispatch();
    const router = useRouter();
    const [form, setForm] = useState({
        submitting: false,
        submitted: false,
        error: false,
        feedbackSubmitted: false,
        valid: false,
        privacyPolicy: 0,
        fields: [
            {
                label: `First name`,
                value: ``,
                error: false,
                fullWidth: false,
                type: "text",
            },
            {
                label: `Last name`,
                value: ``,
                error: false,
                fullWidth: false,
                type: "text",
            },
            {
                label: `Phone number`,
                value: ``,
                error: false,
                fullWidth: false,
                type: "tel",
            },
            {
                label: `Post code`,
                value: ``,
                error: false,
                fullWidth: false,
                type: "postCode",
            },
            {
                label: `Email address`,
                value: ``,
                error: false,
                fullWidth: true,
                type: "email",
            },
        ],
    });

    const recaptchaRef = createRef<ReCAPTCHA>();

    const onCaptchaChange = () => {
        recaptchaRef.current.execute();
    };

    return (
        <div>
            <StyledDialog
                open={modal}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => dispatch(appActions.toggleModal())}
                aria-labelledby="modal-slide-title"
                maxWidth="sm"
                aria-describedby="modal-slide-description"
            >
                <StyledDialogTitle component="div">
                    <StyledIconButton
                        key="close"
                        aria-label="Close"
                        color="inherit"
                        onClick={() => dispatch(appActions.toggleModal())}
                    >
                        <Close/>
                    </StyledIconButton>
                    <h2>Get In touch</h2>
                </StyledDialogTitle>
                <DialogContent id="modal-slide-description" style={{
                    overflowY: `initial`
                }}>
                    {form.error ||
                        (form.submitted && (
                            <Typography variant="h3" component="h3" align="center">
                                Thank you for contacting us.
                                <br/>
                                <br/>
                                We are attending to your enquiry and will respond as soon as
                                possible.
                            </Typography>
                        )) ||
                        (form.submitting && (
                            <>
                                <Typography variant="h3" component="h3" align="center">
                                    Submitting
                                    <br/>
                                    <br/>
                                    <CircularProgress color="secondary"/>
                                </Typography>
                            </>
                        )) || (
                            <>
                                <p>
                                    Submit your contact details and we will get back you in the
                                    next business day to see how we can help you maximise any
                                    compensation you may be entitled to.
                                </p>
                                <Form
                                    noValidate
                                    autoComplete="off"
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        if (form.privacyPolicy < 2)
                                            return setForm({
                                                ...form,
                                                privacyPolicy: 1,
                                            });
                                        handleSubmit(form, setForm, recaptchaRef);
                                    }}
                                >
                                    {form.fields.map((field) =>
                                        field.fullWidth ? (
                                            <FullWidthInput
                                                label={field.label}
                                                key={field.label}
                                                variant="outlined"
                                                value={field.value}
                                                color="secondary"
                                                helperText={field.error}
                                                onChange={(e) =>
                                                    setForm({
                                                        ...form,
                                                        fields: form.fields.map((f) =>
                                                            f.label === field.label
                                                                ? validateInput({...f, value: e.target.value})
                                                                : f
                                                        ),
                                                    })
                                                }
                                            />
                                        ) : (
                                            <TextField
                                                label={field.label}
                                                key={field.label}
                                                variant="outlined"
                                                value={field.value}
                                                color="secondary"
                                                helperText={field.error}
                                                onChange={(e) =>
                                                    setForm({
                                                        ...form,
                                                        fields: form.fields.map((f) =>
                                                            f.label === field.label
                                                                ? validateInput({...f, value: e.target.value})
                                                                : f
                                                        ),
                                                    })
                                                }
                                            />
                                        )
                                    )}
                                    <StyledSubmitGrid alignItems="center">
                                        <Grid container>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        value="privacyPolicy"
                                                        checked={form.privacyPolicy === 2}
                                                        onChange={() =>
                                                            setForm({
                                                                ...form,
                                                                privacyPolicy: form.privacyPolicy < 2 ? 2 : 1,
                                                            })
                                                        }
                                                    />
                                                }
                                                label={
                                                    <>
                                                        I agree to the{" "}
                                                        <a
                                                            href="/privacy-policy"
                                                            target="blank"
                                                            style={{color: "#de4a22"}}
                                                        >
                                                            privacy policy
                                                        </a>
                                                    </>
                                                }
                                            />
                                            {form.privacyPolicy === 1 && (
                                                <FormHelperText>
                                                    Agree to the privacy policy to submit
                                                </FormHelperText>
                                            )}
                                        </Grid>
                                        <Grid container>
                                            <ReCAPTCHA
                                                sitekey={process.env.RECAPTCHA_SITE_KEY}
                                                onChange={() => onCaptchaChange()}
                                                // size="invisible"
                                                ref={recaptchaRef}
                                            />
                                        </Grid>
                                        <Grid container>
                                            {/* <RightAlignGrid item sm={6} xs={12}> */}
                                            <StyledButton variant="outlined" type="submit" style={{marginTop: "1rem"}}>
                                                Submit
                                            </StyledButton>
                                        </Grid>
                                        {/* </RightAlignGrid> */}
                                    </StyledSubmitGrid>
                                </Form>
                            </>
                        )}
                </DialogContent>
                <StyledFooterDialog>
                    <StyledFooterGrid container alignItems="center">
                        <Grid container>
                            <Grid item sm={6}>
                                <OperatingTimes dangerouslySetInnerHTML={{__html: operatingTimes}}/>
                            </Grid>
                            <Grid item sm={6}>
                                <PhoneNumber>
                                    <StyledPhoneIcon/>
                                    <a className="phone_number" href={`tel:${phoneNumber}`} onClick={() => {
                                        {
                                            FbEvent('Contact');
                                            Event({
                                                action: 'click',
                                                category: 'phone call tracking',
                                                event_label: 'Phone Call',
                                                event_action: 'Click to Call'
                                            })
                                        }
                                    }}>
                                        {phoneNumber}
                                    </a>
                                </PhoneNumber>
                            </Grid>
                        </Grid>
                    </StyledFooterGrid>
                </StyledFooterDialog>
            </StyledDialog>
        </div>
    );
}
